import{css}from'glamor';export var hint=css({fontSize:'0.75rem',color:'var(--color-text-medium-emphasis)'});